import axiosClient from '@config/axios';

export const createContact = (contactName, contactEmail, contactMessage) => {
  const params = { name: contactName, email: contactEmail, message: contactMessage };
  return axiosClient.post(`/contact`, params);
};
